/**
 * Asynchronously loads the component for CampusAddEditStudents
 */

import { lazyLoad } from "utils/loadable";

export const CampusAddEditStudents = lazyLoad(
  () => import("./index"),
  (module) => module.CampusAddEditStudents
);
